import { rest } from 'utils';

export default {
  create: ({ properties, dcId }) => rest.post({ url: `/datacenters/${dcId}/networkloadbalancers`, body: { properties } }),
  getAll: ({ dcId } = {}) => rest.get({ url: `/datacenters/${dcId}/networkloadbalancers?depth=4` }),
  get: ({ dcId, id } = {}) => rest.get({ url: `/datacenters/${dcId}/networkloadbalancers/${id}?depth=4` }),
  update: ({ properties, dcId, id }) => rest.put({ url: `/datacenters/${dcId}/networkloadbalancers/${id}`, body: { properties } }),
  delete: ({ dcId, id } = {}) => rest.delete({ url: `/datacenters/${dcId}/networkloadbalancers/${id}` }),
  createForwardingrule: ({ properties, dcId, id }) => (
    rest.post({ url: `/datacenters/${dcId}/networkloadbalancers/${id}/forwardingrules`, body: { properties } })
  ),
  getAllForwardingrule: ({ dcId, id } = {}) => rest.get({ url: `/datacenters/${dcId}/networkloadbalancers/${id}/forwardingrules?depth=4` }),
  getForwardingrule: ({ dcId, id, forwardingRuleId } = {}) => (
    rest.get({ url: `/datacenters/${dcId}/networkloadbalancers/${id}/forwardingrules/${forwardingRuleId}?depth=4` })
  ),
  updateForwardingrule: ({
    properties, dcId, id, forwardingRuleId,
  }) => rest.put({ url: `/datacenters/${dcId}/networkloadbalancers/${id}/forwardingrules/${forwardingRuleId}`, body: { properties } }),
  partiallyUpdateForwardingRule: ({
    properties, dcId, id, forwardingRuleId,
  }) => rest.patch({ url: `/datacenters/${dcId}/networkloadbalancers/${id}/forwardingrules/${forwardingRuleId}`, body: properties }),
  deleteForwardingrule: ({ dcId, id, forwardingRuleId } = {}) => (
    rest.delete({ url: `/datacenters/${dcId}/networkloadbalancers/${id}/forwardingrules/${forwardingRuleId}` })
  ),
};
